/**
 * @file
 * A JavaScript file for the site.
 *
 * @copyright Copyright 2018 Palantir.net
 */

// JavaScript should be made compatible with libraries other than jQuery by
// wrapping it with an "anonymous closure". See:
// - https://drupal.org/node/1446420
// - http://www.adequatelygood.com/2010/3/JavaScript-Module-Pattern-In-Depth

(function ($) {
  'use strict';

  // Use behaviors with context variable.
  Drupal.behaviors.facets = {
    attach: function (context) {

      // Throttle variables
      var $scroll_timeout;
      var $throttle = 200;

      // facet see more button expand
      $('.facet-list__expand').click(function () {
        $(this).toggleClass('is-active');
        $(this).siblings('.facet-list__list').toggleClass('is-active');
      });

      $('.facet-list__list', context).each(function () {
        if ($(this).children().length > 4) {
          $(this).parents('.facet-list').addClass('is-minimized');
        }
      });

      // close filters on `close` button click
      $('.facet-sidebar__mobile-close').click(function () {
        $('.facet-sidebar__mobile-trigger').removeClass('is-active').focus();
        $('.facet-sidebar__container').slideUp();
      });

      // If viewport is smaller than 1050 make the facet trigger active
      let windowsize = $(window).width();
      if (windowsize < 1050) {
        $(once('facet_mobile', '.facet-sidebar__mobile-trigger', context)).each(function () {
          $(this).click(function (event) {
            event.preventDefault();
            $(this).toggleClass('is-active');
            $(this).siblings('.facet-sidebar__container').slideToggle();
          });
        });
      }

      // If viewport is reduced from full size, trigger active
      $(window).resize(() => {
        windowsize = $(window).width();
        if (!$scroll_timeout) {
          $scroll_timeout = setTimeout(function () {
            $scroll_timeout = null;
            if (windowsize < 1050) {
              $(once('facet_mobile','.facet-sidebar__mobile-trigger',context)).each(function () {
                $(this).click(function (event) {
                  event.preventDefault();
                  $(this).toggleClass('is-active');
                  $(this).siblings('.facet-sidebar__container').slideToggle();
                });
              });
            } else {
              // Show sidebar facets when above set breakpoint
              $('.facet-sidebar__container').show();
            }
          }, $throttle);
        }
      });
    }
  };

})(jQuery);
